<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    class="editorial-arrow"
  >
    <path
      d="M7 17 17 7M7 7h10v10"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<style scoped>
.editorial-arrow {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
